import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from 'effector-react';
import { Theme } from '@consta/uikit/Theme';
import { presetLilianiDefault } from './presets/presetLilianiDefault';
import {
  BrowserRouter,
  Route,
  Routes,
  ProtectedRoutes,
  AppRoot,
} from '@lib/routing-engine';
import { $isAuthorized, $isAuthorizing, logout } from '@@/auth/store/auth.store';
import { useGlobalEffects } from '@@/app/hooks/use-global-effects.hook';
import { SideNav } from '@ui/side-nav';
import { AppTemplate } from '@ui/templates';
import { StoragePage } from '@pages/storage';
import { HomePage } from '@@/home/pages/home';
import { MixingPage } from '@@/mixing/pages/mixing';
import { PricesPage } from '@pages/prices';
import { ConservationPage } from '@@/conservation/pages/conservation';
import { SimpleMixingPage } from '@@/mixing/pages/simple-mixing';
import { CreateWarehousePage } from '@pages/create-warehouse';
import { Authorizing } from '@@/auth/components/authorizing';
import { NotFoundPage } from '@@/app/pages/404';
import { APP_SECTIONS } from '@@/common/constants/app-sections.constant';
import { UiButton } from '@@/ui/components/ui-button';
import { closeContextMenu } from '@widgets/storage-viewer/model';

import { DiContainer } from '@@/di/di-container';
import { AuthService } from '@@/auth/services/auth.service';
import { LoggerService } from '@@/common/services/logger.service';

import '@lib/ymaps-arrow';

// TODO: перенести стили в модуль
import './assets/app.css';

const authService = DiContainer.get(AuthService);
const loggerService = DiContainer.get(LoggerService);
if (!PUBLIC_IS_SERVER)
  loggerService.init({
    environment: PUBLIC_MODE,
    dsn: PUBLIC_SENTRY_DSN,
  });

export function App() {
  const isAuthorized = useStore($isAuthorized);
  const isAuthorizing = useStore($isAuthorizing);

  useGlobalEffects();

  // TODO: реализовать механизм glob импорт роутов из модулей
  return (
    <Theme
      preset={presetLilianiDefault}
      onClick={() => closeContextMenu()}
      onAuxClick={() => closeContextMenu()}
    >
      <Authorizing className="app__authorizing" loading={isAuthorizing} />

      <BrowserRouter>
        <Routes>
          <Route element={<AppRoot />}>
            <Route path="/" element={<HomePage />} />

            <Route element={<ProtectedRoutes />}>
              <Route path="/" element={<AppTemplateWithNavigationIfNeeded />}>
                <Route path="/storage" element={<StoragePage />} />
                <Route path="/mixing" element={<MixingPage />} />
                <Route path="/prices" element={<PricesPage />} />
                <Route path="/conservation" element={<ConservationPage />} />
                <Route path="/mixing-simple" element={<SimpleMixingPage />} />
                <Route
                  path="/storage/create-warehouse"
                  element={<CreateWarehousePage />}
                />
                <Route
                  path="/storage/create-warehouse/fixed"
                  element={<CreateWarehousePage />}
                />
              </Route>
            </Route>

            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Theme>
  );
}

/**
 * Этот компонент был создан только чтобы быстро реализовать возможность использовать страницы без SideNav
 * В случае добавления большего количества страниц или смежных функций, лучше отрефакторить механизм шаблонов страниц и роутинга
 * Было необходимо когда главная страница была доступна только авторизованным пользователям
 * @constructor
 */
function AppTemplateWithNavigationIfNeeded() {
  const location = useLocation();
  const navigate = useNavigate();

  const PATH_NAMES_EXCLUDE_NAVIGATION = ['/'];
  const isNavigationNeeded = !PATH_NAMES_EXCLUDE_NAVIGATION.includes(location.pathname);
  const items = APP_SECTIONS.map((section) => ({
    ...section,
    title: section.shortTitle,
  }));

  const onLogout = async () => {
    const result = await authService.logout();
    if (result.success) {
      logout();
      navigate('/');
    }
  };

  return (
    <AppTemplate
      // @ts-ignore
      navigation={isNavigationNeeded && <SideNav items={items} onLogout={onLogout} />}
    />
  );
}
